import { useReducer } from "react"

const inputReducer = (state, action) => {
  if (action.type === "VALUE") {
    return {
      comment: {
        val: action.val,
        valid: action.val.length > 0 ? true : false,
        submit: state.comment.submit,
        block: state.comment.block,
        counter: state.comment.counter,
      },
    }
  }

  if (action.type === "SUBMIT") {
    return {
      comment: {
        val: state.comment.val,
        valid: state.comment.valid,
        submit: true,
        block: true,
        counter: 0,
      },
    }
  }

  if (action.type === "BLUR") {
    return {
      comment: {
        val: state.comment.val,
        valid: state.comment.valid,
        submit: state.comment.submit,
        block: state.comment.block,
        counter: state.comment.counter + 1,
      },
    }
  }

  if (action.type === "BLOCK") {
    return {
      comment: {
        val: state.comment.val,
        valid: state.comment.valid,
        submit: state.comment.submit,
        block: false,
        counter: state.comment.counter,
      },
    }
  }

  return {
    comment: {
      val: "",
      valid: false,
      submit: false,
      block: false,
      counter: 0,
    },
  }
}

const useValidateComment = () => {
  const [inputState, dispatchInput] = useReducer(inputReducer, {
    comment: {
      val: "",
      valid: false,
      submit: false,
      block: false,
      counter: 0,
    },
  })

  const validateHandler = value => {
    dispatchInput({ type: "VALUE", val: value })
    console.log(inputState)
  }

  const submithandler = () => {
    dispatchInput({ type: "SUBMIT" })
  }

  const resetValidate = () => {
    dispatchInput({ type: "RESET" })
  }

  const blurCounter = () => {
    dispatchInput({ type: "BLUR" })
  }

  const removeBlock = () => {
    dispatchInput({ type: "BLOCK" })
  }

  return {
    submithandler,
    validateHandler,
    resetValidate,
    blurCounter,
    removeBlock,
    inputState,
  }
}

export default useValidateComment
